/**
 * Repeater 明細 CRUD 向け AppStatePatch 生成（React 非依存）。
 */
import { isManualAddRepeaterLine } from '../gen1RepeaterLineHelpers';

export function buildRepeaterLineChangeAppStatePatch(
    prev,
    lineSequenceNumber,
    field,
    value
) {
    const serials = prev.gen1Order?.Gen1TrunkingOrderRepeaterSerials ?? [];
    return {
        repeaterSerials: serials.map((line) =>
            line.LineSequenceNumber === lineSequenceNumber
                ? { ...line, [field]: value }
                : line
        ),
    };
}

export function buildAddRepeaterRowAppStatePatch(prev) {
    const currentQty = Math.max(
        0,
        Number(prev.gen1Order?.Gen1TrunkingOrderItem?.RepeaterQty) || 0
    );
    return {
        addRepeater: true,
        trunkingItemPatch: {
            RepeaterQty: currentQty + 1,
        },
    };
}

export function buildDeleteManualRepeaterRowAppStatePatch(
    prev,
    lineSequenceNumber
) {
    const serials = prev.gen1Order?.Gen1TrunkingOrderRepeaterSerials ?? [];
    const nextSerials = serials.filter(
        (line) =>
            !(
                line.LineSequenceNumber === lineSequenceNumber &&
                String(line.OperationType ?? '').toUpperCase() === 'ADD' &&
                line.ExchangePairId == null &&
                isManualAddRepeaterLine(line)
            )
    );
    const currentQty = Math.max(
        0,
        Number(prev.gen1Order?.Gen1TrunkingOrderItem?.RepeaterQty) || 0
    );
    return {
        repeaterSerials: nextSerials,
        trunkingItemPatch: {
            RepeaterQty: Math.max(0, currentQty - 1),
        },
    };
}

export function buildDeleteRemoveRepeaterRowAppStatePatch(
    prev,
    lineSequenceNumber
) {
    const serials = prev.gen1Order?.Gen1TrunkingOrderRepeaterSerials ?? [];
    const isRemoveOnlyLine = (line) =>
        line.OperationType === 'REMOVE' && line.ExchangePairId == null;
    const nextSerials = serials.filter(
        (line) =>
            !(
                line.LineSequenceNumber === lineSequenceNumber &&
                isRemoveOnlyLine(line)
            )
    );
    const currentQty = Math.max(
        0,
        Number(prev.gen1Order?.Gen1TrunkingOrderItem?.RemoveRepeaterQty) || 0
    );
    return {
        repeaterSerials: nextSerials,
        trunkingItemPatch: {
            RemoveRepeaterQty: Math.max(0, currentQty - 1),
        },
    };
}

export function buildDeleteExchangeRepeaterPairAppStatePatch(prev, pairIndex) {
    const serials = prev.gen1Order?.Gen1TrunkingOrderRepeaterSerials ?? [];
    const nextSerials = serials
        .filter((line) => line.ExchangePairId !== pairIndex)
        .map((line) => {
            if (
                line.ExchangePairId != null &&
                line.ExchangePairId > pairIndex
            ) {
                return {
                    ...line,
                    ExchangePairId: line.ExchangePairId - 1,
                };
            }
            return line;
        });
    const currentQty = Math.max(
        0,
        Number(
            prev.gen1Order?.Gen1TrunkingOrderItem?.ExchangeRepeaterPairQty
        ) || 0
    );
    return {
        repeaterSerials: nextSerials,
        trunkingItemPatch: {
            ExchangeRepeaterPairQty: Math.max(0, currentQty - 1),
        },
    };
}

/** Exchange ペア削除で影響する LineSequenceNumber 一覧（validation クリア用）。 */
export function getExchangePairLineSequenceNumbers(serials, pairIndex) {
    return (serials ?? [])
        .filter((line) => line.ExchangePairId === pairIndex)
        .map((line) => line.LineSequenceNumber);
}
